import whiteBars from 'img/bars-white.svg'
import leftArrow from 'img/caret-left.svg'
import rightArrow from 'img/caret-right.svg'
import React from 'react'
import 'css/components/lesson-builder/slide-nav.css'

const computeSlideLabel = (slides, currentIdx) => {
	const current = slides[currentIdx]
	if (!current) return `${currentIdx + 1}`
	const presentationSlides = slides.filter(s => s.type === 'presentation')
	if (current.type === 'presentation') {
		const pos = presentationSlides.findIndex(s => s === current)
		return String(pos + 1)
	} else {
		const parentIdx = presentationSlides.findIndex(s => s.index === current.slide)
		const siblings = slides
			.filter(s => s.type !== 'presentation' && s.slide === current.slide)
			.toSorted((a, b) => a.priority < b.priority)
		const sibPos = siblings.findIndex(s => s === current)
		return `${parentIdx + 1}.${sibPos + 1}`
	}
}

export const SlideNav = ({ slides, currentSlide, onChange, onToggleSidebar }) => {
	const slideLabel = computeSlideLabel(slides, currentSlide)
	const lastSlideLabel = computeSlideLabel(slides, slides.length - 1)

	return (
		<div className="slide-nav">
			<span
				className="toggle-sidebar"
				onClick={onToggleSidebar}
			>
				<img src={whiteBars} />
			</span>
			<span
				className={"prev " + (
					currentSlide === 0 ? 'disable' : ''
				)}
				onClick={() => onChange(currentSlide - 1)}
			>
				<img src={leftArrow} />
			</span>
			<span className="slide-counter">
				{slideLabel} / {lastSlideLabel}
			</span>
			<span
				className={"next " + (
					currentSlide === slides.length - 1 ? 'disable' : ''
				)}
				onClick={() => onChange(currentSlide + 1)}
			>
				<img src={rightArrow} />
			</span>
		</div>
	)
}
